import BlogPostCard from '../components/BlogPostCard';
import '../styles/Blog.css';

import blogPosts from '../data/BlogPostData';
import BlogPostFeaturedCard from '../components/BlogPostFeaturedCard';

const featuredPost = blogPosts[0];
const regularPosts = blogPosts.slice(1);

import updateDocumentTitle from '../utils/updateDocumentTitle';

/**
 * Displays the blog page, maps through blog posts from BlogPostData.
 * 
 * @returns The blog page.
 * 
 * @updated May 28, 2025.
 */

const Blog = () => {

  // hmmf
  updateDocumentTitle('Blog');

  return (
    <div className="blog-page">
      <div className="blog-title-section">
        <div className="container">
          <h2>Blog</h2>
          <p>Clear, practical contract insights to help you navigate the fine print with confidence.</p>
        </div>
      </div>

      <div className="blog-container">
        {/* You can keep this static featured post if you want */}
        <BlogPostFeaturedCard post={featuredPost} />

        <div className="blog-posts">
          {regularPosts.map((post, key) => {
            return <BlogPostCard key={post.id} post={post} />
          })}
        </div>
      </div>
    </div>
  );
};

export default Blog;